export default {
      id: "i-arrow-right-usage",
      viewBox: "0 0 20 9",
      url: __webpack_public_path__ + "img/sprite.svg#i-arrow-right",
      toString: function () {
        return this.url;
      }
    }